export default __webpack_public_path__ + "static/media/flag_western_sahara.77f45222.svg";